<template>
  <div id="page-wrap">
    <div id="header-menu">
      <a
          href="#home-anchor"
          class="qvalent-logo"
          alt="Qvalent logo"
          title="Qvalent logo"
      />

      <ul>
        <li><a href="#home-anchor">Home</a></li>
        <li><a href="#products-anchor">Products</a></li>
        <li><a href="#maintenance-anchor">System Status</a></li>
        <li><a href="#contact-anchor">Contact us</a></li>
      </ul>
    </div>

    <div id="home-anchor" class="anchor"/>

    <main-banner
        :blurbs="[
        'Functional, configurable,\nscalable solutions',
        'Millions of transactions\nprocessed daily',
        'Innovative payment\nplatforms',
        'ISO 20022 expertise',
        'PCI-DSS compliant',
        'Westpac fintech'
      ]"
    />

    <div class="light-bg">
      <div class="inner-content">
        <h1>Who we are</h1>

        <p>
          Qvalent is a wholly owned subsidiary of Westpac Banking Corporation.
          We provide web-based software and support services that enable organisations operating
          in the public, private and not-for-profit sectors to streamline financial business
          processes. Our solutions cover accounts receivable, accounts payable, superannuation and
          payroll event reporting.
        </p>

        <p>
          Represented in Australia since 1997, we operate as an agile and innovative business
          in Newcastle that delivers both the development and support for all our products in-house
          - providing job opportunities and giving back to the local economy.
        </p>

        <p>
          Designed for the Australian and New Zealand markets, our products are fully integrated
          with the banking systems giving access to all major payment channels (including credit
          cards and direct entry). We deliver our 50,000+ business customers with scalable and
          functional solutions, and the support of our software engineers and analysts including
          consulting, implementation and ongoing services.
        </p>

        <p>
          To protect both our customers and our own data, we treat security as a prime concern.
          Backed by the security infrastructure and policies of Westpac, we ensure all financial
          data transmitted between Westpac and our customers is encrypted and digitally signed for
          everyone's protection.
        </p>

        <p>
          Qvalent meets the requirements of the Payment Card Industry Data Security Standard
          (PCI DSS) and has done so continuously for over a decade.
          <a
              href="https://quickstream.westpac.com.au/docs/general/pci-compliance/#pci-compliance"
              target="_blank"
              rel="noopener noreferrer"
          >
            Click here for more information.
          </a>
        </p>
      </div>
    </div>

    <div id="products-anchor" class="anchor"/>

    <div class="dark-bg">
      <div class="inner-content">
        <h1>What we do&#8230;</h1>

        <div id="products">
          <a
              class="product"
              href="https://ilink.westpac.com.au/AboutView"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>iLink</h4>
            <p>
              With multiple host-to-host connectivity options, iLink provides access to directly
              connect to your banking services.
            </p>
          </a>

          <a
              class="product"
              href="https://www.payway.com.au/about"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>PayWay</h4>
            <p>
              A simple and secure solution. With multiple payment channels, PayWay makes it easy for
              customers to pay you.
            </p>
          </a>
          <a
              class="product"
              href="https://paymentsplus.westpac.com.au"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>PaymentsPlus</h4>
            <p>
              A multi-channel online payment solution supporting all your payable needs.
            </p>
          </a>
          <a
              class="product"
              href="https://quickstream.westpac.com.au/#/about"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>QuickStream</h4>
            <p>
              A comprehensive platform. With our extensive range of APIs, QuickStream empowers
              sophisticated businesses to receive and manage payments.
            </p>
          </a>
          <a
              class="product"
              href="https://quicksuper.westpac.com.au/about"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>QuickSuper</h4>
            <p>
              A secure way to manage payments and administration of employee super contributions
              online. Includes reporting facilities to government and fund administrators.
            </p>
          </a>
          <a
              class="product"
              href="https://bankrec.westpac.com.au"
              target="_blank"
              rel="noopener noreferrer"
          >
            <h4>BankRec</h4>
            <p>
              An all-in-one solution for bank statement reconciliation designed to maximise
              the ability to reconcile payments via multiple channels.
            </p>
          </a>
        </div>
      </div>
    </div>

    <div class="light-bg">
      <div id="dev-zone" class="inner-content">
        <h1>Developer Zone</h1>
        <div>
          <div>
            <a
                class="button"
                href="https://ilink.westpac.com.au/docs/rest/"
                target="_blank"
                rel="noopener noreferrer"
            >
              iLink API Reference
            </a>
            <a
                class="button"
                href="https://www.payway.com.au/docs/rest.html"
                target="_blank"
                rel="noopener noreferrer"
            >
              PayWay API Reference
            </a>
            <a
                class="button"
                href="https://paymentsplus.westpac.com.au/docs/wbc/paymentsplusapi/v1"
                target="_blank"
                rel="noopener noreferrer"
            >
              PaymentsPlus API Reference
            </a>
            <a
                class="button"
                href="https://quickstream.westpac.com.au/docs/quickstreamapi/v1"
                target="_blank"
                rel="noopener noreferrer"
            >
              QuickStream API Toolbox
            </a>
          </div>
        </div>
        <h1>ISO 20022 Integration</h1>
        <div>
          <div>
            <a
                class="button button-yellow"
                href="https://bankrec.westpac.com.au/docs/statements/iso/cash-management"
                target="_blank"
                rel="noopener noreferrer"
            >
              BankRec CAMT053
            </a>
            <a
                class="button button-yellow"
                href="https://paymentsplus.westpac.com.au/docs/wbc/payment-processing/iso/payables/#iso-20022-accounts-payable"
                target="_blank"
                rel="noopener noreferrer"
            >
              PAIN001 + PAIN002
            </a>
            <a
                class="button button-yellow"
                href="https://paymentsplus.westpac.com.au/#/iso-sandbox"
                target="_blank"
                rel="noopener noreferrer"
            >
              PAIN001 Validator
            </a>
            <a
                class="button button-yellow"
                href="https://quickstream.westpac.com.au/docs/reporting/iso/receivables/#iso-20022-accounts-receivable"
                target="_blank"
                rel="noopener noreferrer"
            >
              PAIN008
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="maintenance-anchor" class="anchor"/>
    <div id="maintenance" class="dark-bg">
      <div class="inner-content">
        <system-status/>
      </div>
    </div>

    <div id="contact-anchor" class="anchor"/>
    <div id="contact" class="light-bg">
      <div class="inner-content">
        <h1>Get in touch</h1>
        <h4>Banking Enquiries</h4>
        <p>
          For all banking enquiries, the first point of contact is your
          Westpac Relationship Manager. They will be available during normal business hours.
        </p>

        <h4>PayWay</h4>
        <a
            class="button"
            href="https://www.payway.com.au/contact-us"
            target="_blank"
            rel="noopener noreferrer"
        >
          PayWay Technical Support
        </a>

        <h4>PaymentsPlus</h4>
        <a
            class="button"
            href="https://paymentsplus.westpac.com.au/docs/user-guides/#help-and-support"
            target="_blank"
            rel="noopener noreferrer"
        >
          PaymentsPlus Technical Support
        </a>

        <h4>QuickStream</h4>
        <a
            class="button"
            href="https://quickstream.westpac.com.au/docs/support"
            target="_blank"
            rel="noopener noreferrer"
        >
          QuickStream Technical Support
        </a>

        <h4>QuickSuper</h4>
        <a
            class="button"
            href="https://quicksuper.westpac.com.au/enquire"
            target="_blank"
            rel="noopener noreferrer"
        >
          QuickSuper Technical Support
        </a>
      </div>
    </div>
    <div class="dark-bg">
      <div class="inner-content footer">
        &copy; {{ new Date().getFullYear() }} Qvalent Pty Ltd ABN 71 088 314 827.
        <a
            href="https://www.westpac.com.au/privacy/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
        >
          Westpac Privacy Policy
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import MainBanner from '@/components/MainBanner';
import SystemStatus from '@/components/SystemStatus';

export default {
  name: 'App',
  components: {
    MainBanner,
    SystemStatus
  }
};
</script>

<style lang="scss">
@import 'scss/stylesheet';
</style>
